import React, { useState } from 'react'
import styles from './index.module.css'

const UnicomCode = () => {
  const [code, setCode] = useState('')
  const changeVal = (e: any) => {
    const val = e.target.value
    console.log(val)
    setCode(val)
  }
  const goSubmitCode = () => {
    window.location.href = `https://emp.cmpyun.com/equipment/sk/${code}`
  }
  return (
    <div className='flex flex-col justify-center p-6 items-center'>
      <img
        className=' rem:w-[157px] rem:h-[44px] mt-4'
        src='https://static.qiekj.com/h5/alipay/user/login-logo.png'
        alt=''
      />
      <input
        className={`mt-4 w-full h-10 border-b ${styles.input}`}
        placeholder='请输入设备JTCID'
        type='text'
        value={code}
        onChange={changeVal}
      />
      <div onClick={goSubmitCode} className={`mt-6 ${styles.search}`}>
        查询
      </div>
    </div>
  )
}

export default UnicomCode
